import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useTireSeason } from "../blocks/Tires/Results/Filters/TireSeasonFilters/useTireSeason";
import { DealerTiresizeResultsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { TireSearchResultsPayload } from "./useSearchTiresByVehicle";

export const useSearchTiresByTiresize = (
  swrOptions: SWRConfiguration<FetcherResult<TireSearchResultsPayload>> = {}
): ModifiedSWRResponse<
  FetcherResult<TireSearchResultsPayload>,
  TireSearchResultsPayload
> => {
  const route = useRouteParams(DealerTiresizeResultsRoute);

  const [season] = useTireSeason();

  const { data, ...result } = useSwrGet<TireSearchResultsPayload>(
    route ? "/retailSiteWebService/parts/tire/searchTiresByTiresize.php" : null,
    {
      dealerId: route?.dealerId || "",
      originalEquipmentFilter: "ALL",
      season: String(season),
      tireSize: route?.tireSize || "",
    },
    swrOptions
  );

  return { ...result, data };
};
